import React, { useState, useContext, useEffect } from 'react';
import { Typography, Button, Container, Box, FormHelperText } from '@mui/material';

import StripeSplitFields from '../StripCCForm';
import SavedCard from '../SavedCard';

const PaymentForm = (params) => {
  const { paymentMethod, methodUpdated, onSuccess, selectedPlan } = params; // Get payment methods and callbacks from props
  const [showCCForm, setShowCCForm] = useState(false);

  const handleCancel = () => {
    setShowCCForm(false);
  }

  const handleCardUpdated = async () => {
    if (methodUpdated) {
      await methodUpdated();
    }
    if (onSuccess) {
      await onSuccess();
    }
    setShowCCForm(false);
  }

  return (
    <Container maxWidth="sm">
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 3,
        }}>
        {!selectedPlan && (
          <Typography variant="h6" gutterBottom>
            Update Payment Information
          </Typography>
        )}

        <Box sx={{ mt: selectedPlan ? 0 : 3, width: '100%' }}>
          {paymentMethod && !showCCForm && !selectedPlan ? (
            <>
              <SavedCard card={paymentMethod} />

              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={() => { setShowCCForm(true)}}
              >
                Change Payment Method
              </Button>
            </>
          ) : (
            <StripeSplitFields card={paymentMethod} cancel={handleCancel} updated={handleCardUpdated} />
          )}          
        </Box>
      </Box>
    </Container>
  );
};

export default PaymentForm;
